module.exports = __webpack_public_path__ + "img/date5-icon.a18aed6e.png";